import axios from 'axios';
import type { Worksheet } from '@/models/worksheet';
import type { Lesson } from '@/models/lesson';

class TradeWorksheetWebservice {
    public getById(worksheetId: number) {
        return axios.get<Worksheet>('/worksheets/getById', {
            params: {
                worksheetId,
            },
        });
    }

    public store(worksheet: Worksheet, lessons: Lesson[]) {
        return axios.post('/worksheets/store', {
            project_id: worksheet.project.id,
            trade_id: worksheet.trade.id,
            phase_id: worksheet.phase.id,
            lessons,
        });
    }

    public update(worksheet: Worksheet, lessons: Lesson[]) {
        return axios.post('/worksheets/update', {
            worksheet_id: worksheet.id,
            lessons,
        });
    }

    public remove(worksheet: Worksheet) {
        return axios.post('/worksheets/remove', {
            id: worksheet.id,
        });
    }
}

export const tradeWorksheetWebservice = new TradeWorksheetWebservice();
